import { resolveVariant, planPrice } from './p80-purchase-options-logic.js';

/**
 * Subscription card form (Bean Hollow subscriptions page). One select per product
 * option plus a "Deliver every" select; keeps the hidden variant id, the selling
 * plan and the shown prices in sync. Submits as a normal product form to /cart/add.
 *
 * Data comes from a JSON script inside the element:
 * { variants: [{ id, options, available, price, plans: { [planId]: price } }] }
 *
 * @extends {HTMLElement}
 */
class P80SubscribeForm extends HTMLElement {
    connectedCallback() {
        const script = this.querySelector('script[type="application/json"]');
        this.data = script ? JSON.parse(script.textContent || '{}') : { variants: [] };
        this.addEventListener('change', this.#update);
        this.#update();
    }

    disconnectedCallback() {
        this.removeEventListener('change', this.#update);
    }

    #update = () => {
        const selected = [...this.querySelectorAll('select[data-option]')].map(
            (s) => /** @type {HTMLSelectElement} */ (s).value
        );
        const variant = resolveVariant(this.data.variants, selected);
        const idInput = /** @type {HTMLInputElement | null} */ (
            this.querySelector('input[name="id"]')
        );
        const plan = /** @type {HTMLSelectElement | null} */ (
            this.querySelector('select[name="selling_plan"]')
        );
        const button = /** @type {HTMLButtonElement | null} */ (
            this.querySelector('button[type="submit"]')
        );
        if (idInput && variant) idInput.value = String(variant.id);
        if (button) button.disabled = !variant || !variant.available;

        const price = this.querySelector('[data-plan-price]');
        const compare = this.querySelector('[data-compare-price]');
        if (variant && price)
            price.textContent = planPrice(variant.plans, plan?.value, variant.price);
        if (variant && compare) compare.textContent = variant.price;
    };
}

if (!customElements.get('p80-subscribe-form')) {
    customElements.define('p80-subscribe-form', P80SubscribeForm);
}
